import "./FinalCta.css";
import { motion, useReducedMotion } from "framer-motion";

const containerVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1, delayChildren: 0.05 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] } },
};

function FinalCta() {
  const prefersReducedMotion = useReducedMotion();

  const handleStart = () => {
    const emailInput = document.getElementById("landing-email");
    const email = emailInput.value;

    if (!email) return;

    const encodedEmail = encodeURIComponent(email);
    window.location.href = `https://app.tablify.hu/register?email=${encodedEmail}`;
  };

  return (
    <section className="landing-final-cta">
      <div className="final-cta-glow final-cta-glow-1" aria-hidden="true" />
      <div className="final-cta-glow final-cta-glow-2" aria-hidden="true" />
      <div className="final-cta-grid" aria-hidden="true" />

      <motion.div
        className="final-cta-inner"
        initial={prefersReducedMotion ? false : "hidden"}
        whileInView={prefersReducedMotion ? undefined : "show"}
        viewport={{ once: true, amount: 0.4 }}
        variants={prefersReducedMotion ? undefined : containerVariants}
      >
        <motion.span
          className="final-cta-eyebrow"
          variants={prefersReducedMotion ? undefined : itemVariants}
        >
          Kezdd el még ma
        </motion.span>

        <motion.h2 variants={prefersReducedMotion ? undefined : itemVariants}>
          Próbáld ki a Tablify-t
          <br />
          <span>14 napig ingyen</span>
        </motion.h2>

        <motion.p variants={prefersReducedMotion ? undefined : itemVariants}>
          Nincs szükség bankkártyára. Percek alatt beállítható. Bármikor
          lemondható.
        </motion.p>

        <motion.div
          className="final-cta-form"
          variants={prefersReducedMotion ? undefined : itemVariants}
        >
          <label htmlFor="landing-email" className="sr-only">
            Email címed
          </label>
          <input id="landing-email" type="email" placeholder="Email címed" />
          <button onClick={handleStart} className="final-cta-submit">
            Ingyenes Kipróbálás
          </button>
        </motion.div>

        <motion.a
          href="https://teszt-etterem.tablify.hu"
          className="final-cta-secondary"
          variants={prefersReducedMotion ? undefined : itemVariants}
        >
          vagy próbáld ki élőben, regisztráció nélkül →
        </motion.a>

        <motion.div
          className="final-cta-trust-row"
          variants={prefersReducedMotion ? undefined : itemVariants}
        >
          <span>✓ 14 nap ingyenes próba</span>
          <span>✓ Nincs szükség bankkártyára</span>
          <span>✓ Bármikor lemondható</span>
        </motion.div>
      </motion.div>
    </section>
  );
}

export default FinalCta;
